import { Pressable, Text } from "react-native";
import { MessageCircle } from "lucide-react-native";
import { haptic } from "@louise/moon-ui";
import { EMBER } from "../../onboarding/theme";
import {
  pressLabel,
  usePressCapture,
} from "@src/packages/analytics/usePressCapture";

export type ChatAboutArticleButtonProps = {
  label: string;
  accessibilityLabel: string;
  onPress: () => void;
  testID?: string;
};

export function ChatAboutArticleButton({
  label,
  accessibilityLabel,
  onPress,
  testID = "article-chat-about-this",
}: ChatAboutArticleButtonProps) {
  const capturePress = usePressCapture("ChatAboutArticleButton");
  return (
    <Pressable
      testID={testID}
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel}
      onPress={() => {
        capturePress(
          pressLabel(label, accessibilityLabel, testID),
          "chat_about_article",
        );
        haptic("light");
        onPress();
      }}
      style={({ pressed }) => ({
        height: 32,
        flexDirection: "row",
        alignItems: "center",
        gap: 4,
        paddingHorizontal: 10,
        borderRadius: 16,
        backgroundColor: pressed
          ? "rgba(0, 0, 0, 0.08)"
          : "rgba(0, 0, 0, 0.05)",
      })}
    >
      <MessageCircle
        size={14}
        color={EMBER.colors.textLight}
        strokeWidth={1.8}
      />
      <Text
        className="font-dm-sans-medium"
        style={{
          fontSize: 11,
          fontWeight: "500",
          color: EMBER.colors.textLight,
          letterSpacing: 0,
        }}
      >
        {label}
      </Text>
    </Pressable>
  );
}

export default ChatAboutArticleButton;
